import WatchListUpdateReportPage from './WatchListUpdateReportPage';

export default WatchListUpdateReportPage;


// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/index.js